import { render, staticRenderFns } from "./StatusTableColumn.vue?vue&type=template&id=05766788&scoped=true&"
import script from "./StatusTableColumn.vue?vue&type=script&lang=js&"
export * from "./StatusTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./StatusTableColumn.vue?vue&type=style&index=0&id=05766788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05766788",
  null
  
)

export default component.exports